import "../styles/style.css";

export default function StepBar ({ current })  {
  const total = 7; 
  return (
    <div className="step-bar">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={`step-dot ${i === current ? "active" : ""}`}
        ></div>
      ))}
    </div>
  );
};
